import axiosInstance from '../../utils/axiosConfig';   
export async function CompleteMissionRGA(requestData) {
    try {

      const claim = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL_MS_CLAIM}/claim/GetClaimDetails/${requestData.associatedClaim}`); 
      if (!claim) {
        throw new Error("No claim found for given claim number");
      }
        console.log("CompleteMissionRGA :", requestData);
        const data = {
            "completedMissionData": {
              "completionDate": requestData.invoiceDate,
              "damageAmount": requestData.totalRepairAmountWTax ,
              "damageNetAmount": requestData.companyShareWODiscountWTax,
              "feeAmount":requestData.clientShareWTax,   
              "garageCode": requestData.garageCode,
              "honoraryAmount":requestData.companyShareWithDiscountWTax  ,
              "invoiceDate": requestData.invoiceDate,
              "invoiceNumber": requestData.invoice , 
              "repairAmount": requestData.companyShareWithDiscountWTax ,
            },
            "mission": {
              "claimNumber": requestData.associatedClaim ,
              "idMission": claim.data.additionalData.idMissionPi,
              "missionResult":{
                        "codice": "1",
                        "descrizione": "Completé" }  
            }
          }
      const url = `${process.env.REACT_APP_BACKEND_URL_STAR_INTERFACAGE}/completedMissionDataRGA`;
      const response = await axiosInstance.post(url , data); 
      console.log("Response data:", response);
       return response.data;
    } catch (error) {
      console.error(`Error during API call: ${error.message}`);
    }
  }

export async function CompleteMissionExpert(requestData) {
    try {
      const claim = await axiosInstance.get(
        `${process.env.REACT_APP_BACKEND_URL_MS_CLAIM}/claim/GetClaimDetails/${requestData.associatedClaim}`
      );
  
      if (!claim) {
        throw new Error("No claim found for given claim number");
      }
  
      const data = {
        mission: {
          idMission: claim.data.additionalData.idMissionPi,
          claimNumber: requestData.associatedClaim,
          expertCode: requestData.inspectorCode,
          dateDesignation: requestData.designationDate,
          dateFinalisation: requestData.invoiceDate,
          missionResult: {
            codice: "1",
            descrizione: "Completé",
          },
          baremeType: {
            codice: "1",
            descrizione: "Bareme 1",
          },
          invoiceNumber: requestData.invoice,
          invoiceDate: requestData.invoiceDate,
          unitaryPayment: false,
          rgaUsed: claim.data.managementType === "RGA",
        },
        baremeFTUSAData: {
          damageAmount: requestData.totalAmountTcc,
          deductionAmount: requestData.deductionAmounts,
          distanceKm: requestData.travelFee,
          stampFeeAmount: requestData.stampFee,
          variousFeeAmount: requestData.variousFee || 0,
        },
        rejectionData: {},
        cancellationData: {},
      };
  
      const url = `${process.env.REACT_APP_BACKEND_URL_STAR_INTERFACAGE}/expertCarMissionResult`;
      const response = await axiosInstance.post(url, data);
  

      console.log("Return Code :",  response.data);
  
      return response.data 
    } catch (error) {
      console.error(`Erreur lors de l'appel API : ${error.message}`);
      return {
        success: false,
        error: error.message,
      };
    }
  }
  